var _circle, _circle2, _circle3, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.8056,
    cy: 3.0815,
    r: 2.26195,
    transform: "rotate(-15 11.8056 3.0815)",
    fill: "#474C55",
    stroke: "#474C55",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.17393,
    cy: 8.86955,
    r: 2.96739,
    fill: "#474C55",
    stroke: "#474C55",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7826,
    cy: 14.7826,
    r: 2.96739,
    fill: "#474C55",
    stroke: "#474C55",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.3994,
    y1: 4.08611,
    x2: 6.70373,
    y2: 7.04263,
    stroke: "#474C55"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.63943,
    y1: 9.91372,
    x2: 11.8133,
    y2: 12.8702,
    stroke: "#474C55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon_link.cd880eeea5e5af75f0ce7ec983e42664.svg";
export { ForwardRef as ReactComponent };